import type { FC } from "react";
import { Card, RenderMd } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { YStack } from "tamagui";

import { api } from "~/utils/api";
import { OverviewCard } from "./overview-common";

export const OverviewInsights: FC = () => {
  const { t } = useTranslation("overview");
  const [data] = api.overview.insights.useSuspenseQuery();

  return (
    <OverviewCard title={t("insights.title")} subtitle={t("insights.subtitle")}>
      <YStack width="100%" flex={1} gap={"$2"}>
        {data.map((insight, index) => (
          <InsightCard
            key={index}
            title={insight.title}
            subtitle={t("insights.recommendation")}
            description={insight.text}
          />
        ))}
      </YStack>
    </OverviewCard>
  );
};

const InsightCard: FC<{
  title: string;
  subtitle: string;
  description: string;
}> = ({ title, subtitle, description }) => {
  return (
    <Card
      variant="borderless"
      borderRadius={"$2"}
      borderLeftWidth={"$1"}
      borderColor={"$gray-600"}
      backgroundColor={"$warning-100"}
      paddingHorizontal={"$6"}
      paddingVertical={"$4"}
    >
      <YStack>
        <Card.Title
          textAlign="left"
          fontSize={"$6"}
          lineHeight={"$6"}
          marginBottom={"$1"}
        >
          {title}
        </Card.Title>
        <Card.Subtitle textAlign="left" fontWeight={500}>
          {subtitle}
        </Card.Subtitle>
        <RenderMd md={description} />
      </YStack>
    </Card>
  );
};
